import React, { useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";

/**
 * "Request refund" for one confirmed payment. Only asks a Superadmin to record a full refund that was
 * already paid outside the system; nothing is recorded until the request is approved.
 */
export default function RefundRequestModal({ show, payment, saving, onHide, onSubmit }) {
  const [reason, setReason] = useState("");
  const [refundReference, setRefundReference] = useState("");
  const submitLock = useRef(false);

  const reset = () => {
    setReason("");
    setRefundReference("");
  };

  const close = () => {
    if (saving) return;
    reset();
    onHide();
  };

  const canSubmit = reason.trim().length >= 3 && refundReference.trim() && !saving;

  const submit = async (event) => {
    event.preventDefault();
    if (submitLock.current || !canSubmit) return;
    submitLock.current = true;
    try {
      const succeeded = await onSubmit({
        payment_id: payment?.id,
        reason: reason.trim(),
        refund_reference: refundReference.trim(),
      });
      if (succeeded !== false) reset();
    } finally {
      submitLock.current = false;
    }
  };

  return (
    <Modal show={show} onHide={close} centered>
      <Modal.Header closeButton={!saving}>
        <Modal.Title>Request refund</Modal.Title>
      </Modal.Header>
      <form onSubmit={submit}>
        <Modal.Body>
          <div className="alert alert-warning">
            Full refund only. This asks a Superadmin to record a refund that was already made outside the system;
            no money is moved and partial refunds are not supported.
          </div>
          <p className="mb-3">
            Amount to refund: <strong>৳{Number(payment?.amount || 0).toLocaleString()}</strong> (the full payment)
          </p>
          <label className="form-label" htmlFor="refund-request-reason">Reason</label>
          <textarea
            id="refund-request-reason"
            className="form-control mb-3"
            value={reason}
            onChange={(event) => setReason(event.target.value)}
            required
          />
          <label className="form-label" htmlFor="refund-request-reference">External refund reference</label>
          <input
            id="refund-request-reference"
            className="form-control"
            value={refundReference}
            onChange={(event) => setRefundReference(event.target.value)}
            required
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={close} disabled={saving}>Cancel</Button>
          <Button type="submit" variant="danger" disabled={!canSubmit}>
            {saving ? "Sending…" : "Send request"}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
